import { render, staticRenderFns } from "./PensionClean.vue?vue&type=template&id=c8a24b1e&"
import script from "./PensionClean.vue?vue&type=script&lang=js&"
export * from "./PensionClean.vue?vue&type=script&lang=js&"
import style0 from "./PensionClean.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports